import { Button } from 'react-bootstrap';
import React = require('react');

interface IRecalculateButtonProps {
  text?: string;
  handleRecalculate: () => any;
  valid: boolean;
  block: boolean;
  isCalculating: boolean;
  disable?: boolean;
}

export const RecalculateButton = ({
                                    text,
                                    handleRecalculate,
                                    valid,
                                    block = false,
                                    isCalculating,
                                    disable = false
                                  }: IRecalculateButtonProps) => {
  return (
    <Button
      bsSize={'small'}
      type="button"
      block={block}
      disabled={!valid || isCalculating || disable}
      onClick={handleRecalculate}
      className={'admiral-primary-btn'}>
      {text || 'APPLY CHANGES'}
    </Button>
  )
}
